import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

import { SearchCriteriaModel } from 'stores/models';

import { UitkCheckbox } from 'uitk-react-checkbox';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { FormFieldBinding } from 'src/common/components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'src/common/components/common/search-form';

interface FlightNonStopCheckboxProps extends LocalizedComponentProps, SearchFormFieldProps {
  model: SearchCriteriaModel;
}

// @ts-ignore
@withLocalization
@FormFieldBinding
export class FlightNonStopCheckbox extends React.Component<FlightNonStopCheckboxProps> {
  private name: string;
  private label: string;

  constructor(props: FlightNonStopCheckboxProps) {
    super(props);

    this.name = props.modelKey;
    this.label = props.l10n.formatText('multiItem.searchWizard.directFlightsOnly');

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { updateModel, modelKey } = this.props;

    if (typeof updateModel === 'function') {
      const { checked } = event.target;

      updateModel({
        target: {
          name: modelKey,
          value: String(checked),
          track: true,
        },
      });
    }
  }

  public render() {
    return (
      <UitkLayoutGridItem colSpan="all">
        <div>
          <UitkCheckbox
            id={this.name}
            name={this.name}
            value={this.props.model.directFlights}
            checked={this.props.model.directFlights === 'true'}
            onChange={this.handleChange}
          >
            {this.label}
          </UitkCheckbox>
        </div>
      </UitkLayoutGridItem>
    );
  }
}
